import { ValidatorFn } from '@angular/forms';
import { RxwebValidators } from '@rxweb/reactive-form-validators';

/** Mirrors `SignupRequest` / `ResetRequest` in cloudclass-auth: 8–60 chars with lower, upper, digit and symbol. */
export const STRONG_PASSWORD_PATTERN = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,60}$/;

export const STRONG_PASSWORD_HINT = 'Mínimo de 8 caracteres, com letra maiúscula, minúscula, número e símbolo.';

/** Validators for a new password field; rxweb reports the pattern failure under the `strongPassword` error key. */
export function buildNewPasswordValidators(): ValidatorFn[] {
  return [RxwebValidators.required(), RxwebValidators.pattern({ expression: { strongPassword: STRONG_PASSWORD_PATTERN } })];
}
